import { useTranslationsProvider, useIntl } from '@mfw/components';
import Box from '@mui/material/Box';
import React from 'react';

import { useUploadWorkerContext } from '../../../context';
import { getLabelFromTranslations } from '../../../utils';
import { RemoveUploadDialog } from './RemoveUploadDialog';
import EmptyContent from '../EmptyContent/EmptyContent';
import { UploadProgress } from '../../../components';
import messages from './messages';

interface NotificationItemProps {
  id: string;
}

const NotificationItem = ({ id }: NotificationItemProps) => {
  const { dequeTask, getTaskById } = useUploadWorkerContext();
  const { formatMessage } = useIntl();
  const { locale } = useTranslationsProvider();
  const task = getTaskById(id);
  const [isRemoveDialogOpened, setRemoveDialogOpened] = React.useState(false);

  return (
    <>
      <RemoveUploadDialog
        onCancel={() => setRemoveDialogOpened(false)}
        onConfirm={() => dequeTask({ id })}
        open={isRemoveDialogOpened}
      />
      <UploadProgress
        title={getLabelFromTranslations(locale, task?.meta.translations)}
        file={task?.meta.coverFile || task?.meta.coverSignedUrl}
        onRemove={() => setRemoveDialogOpened(true)}
        description={task?.meta?.organizationName}
        // `failTask` has set this since the worker learned to report a failed
        // PUT; nothing read it, so a failed upload sat frozen at its last
        // percentage and looked like one still running.
        error={task?.status === 'error'}
        errorLabel={formatMessage(messages.failed)}
        progress={task?.progress || 0}
      />
    </>
  );
};

export const NotificationsUploads = () => {
  const { tasks } = useUploadWorkerContext();
  const { formatMessage } = useIntl();
  return (
    <Box>
      {tasks.map((task) => (
        <NotificationItem key={task.id} id={task.id} />
      ))}
      {tasks.length === 0 && (
        <EmptyContent label={formatMessage(messages.noContent)} />
      )}
    </Box>
  );
};
